<template>
  <div class="row">
    <div class="span8 list-main">
      <h1 class="list-title">文章/新闻<small>{{ tag ? '标签：' + tag : '' }}</small></h1>
      <ul class="tabs-nav">
        <li :class="{ active: pagelistquery.lable === '' }" @click="changelable('')">全部</li>
        <li v-if="tag" :class="{ active: tagActive }" @click="tagActive = true">{{ tag }}</li>
        <li v-for="item in lables" :key="item" :class="{ active: pagelistquery.lable === item }" @click="changelable(item)">{{ item }}</li>
      </ul>
      <div v-for="item in tableData" :key="item.article_id" class="news-item">
        <h2><router-link :to="`/newscontent/${item.article_id}`">{{ item.article_title }}</router-link></h2>
        <div class="meta">
          <span>🕐 {{ item.article_createtime | dataFormat }}</span>
          <span>作者：{{ item.nickname }}</span>
          <span>3 Comments</span>
          <span>👁 {{ item.article_read_num }}</span>
        </div>
        <p>{{ item.article_introduction }}<router-link :to="`/newscontent/${item.article_id}`"> ...查看更多</router-link></p>
      </div>
      <div class="pagination-wrap">
        <el-pagination
          layout="prev, pager, next"
          :total="pagelistquery.total"
          :page-size="5"
          @current-change="getlist"
        ></el-pagination>
      </div>
    </div>
    <div class="span4 page-sidebar">
      <carousel-widget />
      <oldstuffhot-widget />
    </div>
  </div>
</template>

<script>
import carouselWidget from '@/components/carousel.vue'
import oldstuffhotWidget from '@/components/oldstuffhot.vue'
import { getArticleList, getLable } from '@/api'

export default {
  name: 'News',
  components: { carouselWidget, oldstuffhotWidget },
  props: { tag: { type: String, default: '' } },
  data() {
    return {
      lables: [],
      tagActive: true,
      tableData: [],
      pagelistquery: { lable: '', tag: this.tag || '', page: 1, total: 0 }
    }
  },
  created() {
    getLable('文章分类').then((res) => {
      this.lables = JSON.parse(res.data[0].lable) || []
    })
    this.getlist(1)
  },
  methods: {
    getlist(page) {
      this.pagelistquery.page = page
      getArticleList({ ...this.pagelistquery, pagesize: 5 }).then((res) => {
        this.tableData = res.data || []
        this.pagelistquery.total = res.count || 0
      })
    },
    changelable(lable) {
      this.pagelistquery.lable = lable
      this.tagActive = false
      this.getlist(1)
    }
  }
}
</script>
